export enum CustomLinkType {
  Url = 0,
  File = 1
}

export interface CustomLink {
  id: string;
  name: string;
  linkType: CustomLinkType;
  url?: string;
  icon?: string;
  description?: string;
  sortOrder: number;
  isActive: boolean;
  groupName?: string;  // If set, appears under this submenu; empty = top level
  fileName?: string;
  fileContent?: string; // Base64 encoded
  mimeType?: string;
  hasFile?: boolean;
  auditInsertDate?: Date;
  auditUpdateDate?: Date;
}

export interface CreateCustomLinkDto {
  name: string;
  linkType: CustomLinkType;
  url?: string;
  icon?: string;
  description?: string;
  sortOrder?: number;
  isActive?: boolean;
  groupName?: string;
  fileName?: string;
  fileContent?: string;
  mimeType?: string;
}

export interface UpdateCustomLinkDto extends Partial<CreateCustomLinkDto> {
  id: string;
}
